import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MOCK_MANUFACTURER_MODELS } from "../data";
import {
  ManufacturerModelForm,
  ManufacturerModelLicensingWeightFilter,
  ManufacturerModelManufacturerFilter,
  ManufacturerModelMasterModelFilter,
  ManufacturerModelYearFilter,
} from "../types";
import { initialManufacturerModelForm, initialState } from "./initialState";

export const sliceKey = "manufacturerModelState";

const manufacturerModelSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getManufacturerModelsList(state) {
      state.loading = false;
      state.error = null;
      state.list = MOCK_MANUFACTURER_MODELS;
    },

    setManufacturerFilter(
      state,
      action: PayloadAction<ManufacturerModelManufacturerFilter>
    ) {
      state.manufacturerFilter = action.payload;
    },

    setMasterModelFilter(
      state,
      action: PayloadAction<ManufacturerModelMasterModelFilter>
    ) {
      state.masterModelFilter = action.payload;
    },

    setYearFilter(state, action: PayloadAction<ManufacturerModelYearFilter>) {
      state.yearFilter = action.payload;
    },

    setLicensingWeightFilter(
      state,
      action: PayloadAction<ManufacturerModelLicensingWeightFilter>
    ) {
      state.licensingWeightFilter = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.form = initialManufacturerModelForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof ManufacturerModelForm;
        value: string | boolean;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value as never;
    },

    resetForm(state) {
      state.form = initialManufacturerModelForm;
    },

    addManufacturerModel(state) {
      state.isAddModalOpen = false;
      state.form = initialManufacturerModelForm;
    },
  },
});

export const { actions: manufacturerModelActions, reducer } =
  manufacturerModelSlice;
